import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  Inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Activity } from '../../activities/activities.types';
import QRCode from 'qrcode';
import { ToastService } from '../../../../services/toast.service';
import { ToastTypeEnum } from '../../toast/toast.type';
import { activityTypeLabels } from '../../activities/activities.constants';
import { DayjsFormatPipe } from '../../../../pipes/date.pipe';

@Component({
  selector: 'app-modal-show-qr-code',
  imports: [ModalHeaderComponent, DayjsFormatPipe],
  templateUrl: './modal-show-qr-code.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalShowQrCodeComponent implements OnInit {
  static overlayDataType: { activity: Activity };

  private readonly toastService = inject(ToastService);

  public dataUrl = signal<string | null>(null);

  @ViewChild('qrCanvas', { static: true }) qrCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: typeof ModalShowQrCodeComponent.overlayDataType
  ) {}

  readonly activityTypeLabel = computed(() => activityTypeLabels[this.data.activity.type]);

  ngOnInit(): void {
    if (this.data.activity) {
      const canvas = this.qrCanvas.nativeElement;
      const container = canvas.parentElement;

      if (container) {
        const containerWidth = container.clientWidth;

        // Setze die internen Canvas-Dimensionen
        canvas.width = containerWidth;
        canvas.height = containerWidth;

        // Setze die CSS-Größe für responsives Verhalten
        canvas.style.width = '100%';
        canvas.style.height = '100%';

        QRCode.toCanvas(
          canvas,
          this.data.activity.checkInCode,
          {
            width: containerWidth,
            margin: 0,
            color: {
              dark: '#000000',
              light: '#ffffff',
            },
          },
          (error) => {
            if (error) {
              console.error('QR Code Fehler:', error);
              // Optional: Zeige eine Toast-Nachricht an
              this.toastService.addToast('QR Code Fehler', ToastTypeEnum.ERROR);
            }
          }
        );
      }
    }
  }
}
